// extracted by mini-css-extract-plugin
export default {"list":"BlogList_list__HbJDI","item":"BlogList_item__2twL6","more":"BlogList_more__5itky"};